<template lang="pug">
    div.sustainability
        navbar
        section.section.section-1.is-fullview.is-parallax
            div.is-vmiddle
                div.container.has-text-white.has-text-centered
                    h1.is-size-2.is-uppercase.animated.fadeInUp.slow(v-html="$t('page_06.title')")

        section.section.section-2
            div.container
                div.columns.is-centered
                    div.column.is-2.has-text-centered
                        img.sustainability-logo(src="../assets/images/6_sustentabilidade/EWF_logos.svg")
                div.has-text-centered
                    div.is-inline-block.is-trace
                    h1.is-size-32.is-uppercase.has-line-height(v-html="$t('page_06.block_1.title')")
                    h3.is-size-26.has-line-height(v-html="$t('page_06.block_1.text_1')")
                div.columns.is-centered
                    div.column.is-8.has-text-centered
                        p {{ $t('page_06.block_1.text_2') }}

        section.section
            div.has-text-right
                img.image-anchor(src="../assets/images/6_sustentabilidade/sustentabilidade-1.jpg")

        //- social
        section.section
            div.container.has-padding-mobile
                div.columns
                    div.column.is-8.is-offset-4.has-text-centered-mobile
                        h2.is-size-11.is-uppercase.has-letter-spacing-200 {{ $t('page_06.block_2.subtitle') }}
                        h1.is-size-32.is-uppercase.has-line-height {{ $t('page_06.block_2.title_01') }}
                        h1.is-size-32.is-uppercase.has-line-height {{ $t('page_06.block_2.title_02') }}
                        p {{ $t('page_06.block_2.text_1') }}

        section.section.section-5
            div.columns
                div.column.is-8.is-offset-4
                    img.is-block.is-fullw.thumbnail-parallax(src="../assets/images/6_sustentabilidade/social-2.jpg")
            div.container.is-paddingless.is-up.is-hidden-mobile
                div.columns
                    div.column.is-4
                        img.is-block.is-fullw.thumbnail-parallax(src="../assets/images/6_sustentabilidade/social-1.jpg")

        section.section
            div.container
                div.columns.has-text-centered-mobile
                    div.column
                        h2.is-size-11.is-uppercase.has-letter-spacing-200.has-line-height-4-5(v-html="$t('page_06.block_3.subtitle')")
                    div.column.is-8.has-text-justified.has-text-centered-mobile
                        p.is-size-22.has-line-height-2(v-html="$t('page_06.block_3.text_1')")

        section.section.section-7
            div.columns
                div.column.is-8
                    img.is-block.is-fullw(src="../assets/images/6_sustentabilidade/social-4.jpg")
            div.container.is-paddingless.is-up
                div.columns
                    div.column.is-offset-8.has-text-centered-mobile
                        img.is-block.is-fullw.parceiro-logo(src="../assets/images/6_sustentabilidade/social-3.png")

        section.section.section-8.has-background-blue
            div.container.has-text-centered.has-text-grey.is-paddingless
                div.columns.is-centered
                    div.column.is-4(v-for="i in $t('page_06.block_4')")
                        a(:href="'http://' + i.url" target="_blank")
                            h1.is-size-30.is-marginless {{ i.name }}
                            p.is-size-20 {{ i.url }}

        section.section
            img.is-block.is-fullw(src="../assets/images/6_sustentabilidade/social-5.jpg")

        section.section
            div.container
                div.columns
                    div.column.is-8.is-offset-4.has-text-centered-mobile
                        h2.is-size-11.is-uppercase.has-letter-spacing-200 {{ $t('page_06.block_5.subtitle') }}
                        h1.is-size-32.is-uppercase(v-html="$t('page_06.block_5.title')")
                        p(v-html="$t('page_06.block_5.text_1')")

        section.section.section-11
            div.columns.is-paddingless.is-hidden-mobile
                div.column.is-8.is-offset-4
                    img.is-block.is-fullw.thumbnail-parallax(src="../assets/images/6_sustentabilidade/ambiental-2.jpg")
            div.container.is-paddingless.is-up
                div.columns
                    div.column.is-4
                        img.is-block.is-fullw.thumbnail-parallax(src="../assets/images/6_sustentabilidade/ambiental-1.jpg")

        section.section
            div.container
                div.columns
                    div.column.is-8.is-offset-4.has-text-centered-mobile
                        h2.is-size-22.has-line-height-2(v-html="$t('page_06.block_6.text_1')")
                        p.has-line-height-1-75(v-html="$t('page_06.block_6.text_2')")

        section.section.section-13
            div.container.is-paddingless
                div.columns
                    div.column.is-8
                        img.is-block.is-fullw.thumbnail-parallax(src="../assets/images/6_sustentabilidade/ambiental-3.jpg")
                div.columns.is-up
                    div.column.is-4.is-offset-8
                        img.is-block.is-fullw.thumbnail-parallax(src="../assets/images/6_sustentabilidade/ambiental-4.jpg")

        section.section
            div.container
                div.columns
                    div.column.is-8.is-offset-4.has-text-centered-mobile
                        p.is-size-22.has-line-height-2(v-html="$t('page_06.block_7.text_1')")

        section.section
            img.is-block.is-fullw(src="../assets/images/6_sustentabilidade/ambiental-5.jpg")

        the-footer
</template>

<script>
// import simpleParallax from 'simple-parallax-js'

import Navbar from '@/components/the-navbar'
import TheFooter from '@/components/the-footer'

export default {
    name: 'sustainability',
    components: { Navbar, TheFooter },
    mounted () {
        // disabled .thumbnail-parallax
        // const images = document.getElementsByClassName('thumbnail-parallax')
        // const instances = new simpleParallax(images)
        this.pullRight()
    },
    methods: {
        pullRight () {
            const element = document.getElementsByClassName('image-anchor')[0]
            const containerLeft = document.getElementsByClassName('container')[1].getBoundingClientRect().left
            const clientWidth = document.documentElement.clientWidth - containerLeft
            element.style.width = clientWidth + 'px'
        }
    }
}
</script>

<style lang="stylus" scoped>

.sustainability
    &-logo
        @media screen and (max-width: 768px)
            width 35vw

.section > .container
    padding 6% 0
    h1, h3
        margin-bottom 2rem
    h2
        margin-bottom 1rem
    h1 + h1
        margin-top -2rem

    @media screen and (max-width 768px)
        padding-left 10px
        padding-right 10px

.section-1
    background-image url("../assets/images/6_sustentabilidade/Sustentabilidade_banner.jpg")
    background-size cover

    @media screen and (max-width: 768px)
        background-image url("../assets/images/6_sustentabilidade/Sustentabilidade_banners-mobile.jpg")

    .is-trace
        height 3rem
        margin-top 2rem
        width 1px

.section-2
    .is-trace
        background-color #465670
        height 2rem
        margin 2rem 0
        width 1px

.is-logo
    width 5rem

.section-5
    @media screen and (min-width: 1024px)
        .is-up
            margin-top -24%

.section-7
    @media screen and (min-width: 1024px)
        .is-up
            margin-top -300px
.section-8
    margin-top -14.5%
    padding-top 21%
    padding-bottom 10%

.section-11
    @media screen and (min-width: 1024px)
        .is-up
            margin-top -25%

.section-13
    @media screen and (min-width: 1024px)
        .is-up
            margin-top -36%

.has-line-height-4-5
    line-height 4.6
a
    color unset

    &:hover
        color unset

.parceiro-logo
    @media screen and (max-width 768px)
        max-width 35vw
        margin 0 auto

</style>
